class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick?.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector(event) {
    const mq = window.matchMedia("(max-width: 1199px)");
    if (mq.matches) {
      const shouldClose =
        event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
      if (event.relatedTarget === null || shouldClose) this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

//
// Reposition Country Selector for Mobile & Desktop on Load & Resize
//
const config = {
  countrySelector: "localization-form",
  mobileNav: ".menu-drawer__utility-links",
  desktopPlacement: ".header__inline-menu-top",
  // For PDP - reusing the insertAfter function
  productMultiCol: ".section-multicolumn-pdp > div",
  productAccordion: ".section.product-details-section > div",
  sectionsPlacement: ".product__info-container > .product__title",
};

const $countrySelector = document.querySelector(config.countrySelector);
const $mobileNav = document.querySelector(config.mobileNav);
const $desktopPlacement = document.querySelector(config.desktopPlacement);

// For PDP - reusing the insertAfter function
const $productMultiCol = document.querySelector(config.productMultiCol);
const $productAccordion = document.querySelector(config.productAccordion);
const $sectionsPlacement = document.querySelector(config.sectionsPlacement);

function insertAfter(referenceNode, newNode) {
  referenceNode?.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function insertBefore(referenceNode, newNode) {
  referenceNode?.parentNode.insertBefore(
    newNode,
    referenceNode.previousSibling
  );
}

// For PDP - reusing the insertAfter function
if (typeof $productMultiCol != "undefined" && $productMultiCol != null) {
  insertAfter($sectionsPlacement, $productMultiCol);
}

if (typeof $productAccordion != "undefined" && $productAccordion != null) {
  insertAfter($sectionsPlacement, $productAccordion);
}

function localizationFormPlacement() {
  const mq = window.matchMedia("(max-width: 1199px)");
  if (mq.matches) {
    insertAfter($mobileNav, $countrySelector);
  } else {
    insertBefore($desktopPlacement, $countrySelector);
  }
}
